import type { AbstractIntlMessages } from "use-intl";
import type { Locale } from "@/config/i18n.config";

export async function loadMessages(locale: Locale): Promise<AbstractIntlMessages> {
  switch (locale) {
    case "pt":
      return (await import("@/locales/pt.json")).default as AbstractIntlMessages;
    case "es":
      return (await import("@/locales/es.json")).default as AbstractIntlMessages;
    case "hi":
      return (await import("@/locales/hi.json")).default as AbstractIntlMessages;
    case "en":
    default:
      return (await import("@/locales/en.json")).default as AbstractIntlMessages;
  }
}
